import _regeneratorRuntime from "/Users/research/Downloads/\u5316\u5C0F\u5317\u524D\u7AEF\u6E90\u7801-24-11-17/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/research/Downloads/\u5316\u5C0F\u5317\u524D\u7AEF\u6E90\u7801-24-11-17/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, unref as _unref, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/loginbg.png';
import _imports_1 from '@/assets/bg_video.mp4';
import _imports_2 from '@/assets/loginli.png';
import _imports_3 from '../assets/Vector.png';
import _imports_4 from '../assets/Subtract.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-57664d08"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "login_page"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "login_video"
  }, [/*#__PURE__*/_createElementVNode("video", {
    autoplay: "",
    muted: "",
    loop: "",
    playsinline: "",
    poster: _imports_0
  }, [/*#__PURE__*/_createElementVNode("source", {
    src: _imports_1,
    type: "video/mp4"
  })]), /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }), /*#__PURE__*/_createElementVNode("h6", null, "化小北·化学实验智慧学伴"), /*#__PURE__*/_createElementVNode("span", null, " 知识问答·方案自评·报告自评")])], -1);
});
var _hoisted_3 = {
  "class": "login_form"
};
var _hoisted_4 = ["onSubmit"];
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  }, null, -1);
});
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  }, null, -1);
});
var _hoisted_7 = ["disabled"];
var _hoisted_8 = {
  key: 0,
  width: "18",
  height: "18",
  viewBox: "0 0 100 100",
  "class": "spinner"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("circle", {
    cx: "50",
    cy: "50",
    r: "35"
  }, null, -1);
});
var _hoisted_10 = [_hoisted_9];
import { ref, inject } from "vue";
import { useRouter } from "vue-router";
import { login } from "@/api/common";
export default {
  __name: 'Login',
  setup: function setup(__props) {
    var _inject = inject("useToast"),
      toasts = _inject.toasts,
      addToast = _inject.addToast;
    var username = ref("");
    var password = ref("");
    var router = useRouter();
    var handleSubmit = function handleSubmit() {
      // 在此处理登录逻辑，例如发送请求到后端
      console.log("账号:", username.value);
      console.log("密码:", password.value);
      var objData = {
        account: username.value,
        password: password.value
      };
      _login(objData);

      // 可以在此处调用 API 进行登录验证
    };

    var isLoading = ref(false);
    var _login = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(objData) {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!isLoading.value) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", false);
            case 2:
              isLoading.value = true;
              _context.prev = 3;
              _context.next = 6;
              return login(objData);
            case 6:
              res = _context.sent;
              console.log(res);
              addToast("登录成功", "success");
              _context.next = 11;
              return localStorage.setItem("token", res.data.token);
            case 11:
              _context.next = 13;
              return localStorage.setItem("account", objData.account);
            case 13:
              router.push({
                path: "/"
              });
            case 14:
              _context.prev = 14;
              isLoading.value = false;
              username.value = "";
              password.value = "";
              return _context.finish(14);
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3,, 14, 19]]);
      }));
      return function _login(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      var _component_Toast = _resolveComponent("Toast");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("form", {
        onSubmit: _withModifiers(handleSubmit, ["prevent"])
      }, [_createElementVNode("div", null, [_hoisted_5, _withDirectives(_createElementVNode("input", {
        type: "text",
        id: "username",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return username.value = $event;
        }),
        required: "",
        placeholder: "请输入账号"
      }, null, 512), [[_vModelText, username.value]])]), _createElementVNode("div", null, [_hoisted_6, _withDirectives(_createElementVNode("input", {
        type: "password",
        id: "password",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return password.value = $event;
        }),
        required: "",
        placeholder: "请输入密码"
      }, null, 512), [[_vModelText, password.value]])]), _createElementVNode("button", {
        disabled: isLoading.value,
        type: "submit"
      }, [_createTextVNode(" 登录 "), isLoading.value ? (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_10)) : _createCommentVNode("", true)], 8, _hoisted_7)], 40, _hoisted_4)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toasts), function (toast, index) {
        return _openBlock(), _createBlock(_component_Toast, {
          key: index,
          message: toast.message,
          type: toast.type
        }, null, 8, ["message", "type"]);
      }), 128))]);
    };
  }
};